import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/services/user-services/auth.service';
import { CallApiService } from 'src/app/core/services/user-services/call-api.service';
import { RedisStorage } from 'src/app/models/RedisStorage';
import {HttpClient, HttpParams} from '@angular/common/http';
import { ConstService } from 'src/app/core/services/user-services/const.service';

@Component({
  selector: 'app-test-user',
  templateUrl: './test-user.component.html',
})
export class TestUserComponent {
  isLoginEnabled: boolean;
  isLogoutEnabled: boolean;
  isCallApiEnabled: boolean;
  value: any;
  redis_storage: RedisStorage;

  constructor(public authService: AuthService,
              private callApiService: CallApiService,
              private constService: ConstService,
              private httpClient: HttpClient) {
    this.authService.isLoggedIn().then(isLoggedIn => {
      this.isLoginEnabled = !isLoggedIn;
      this.isLogoutEnabled = !this.isLoginEnabled;
      this.isCallApiEnabled = isLoggedIn;
    });

    this.redis_storage = new RedisStorage(this.httpClient, this.constService);
  }

  login() {
    this.authService.login().then();
  }

  setRedis() {
    this.redis_storage.set('Pippo', 'Baudo');
  }

  getRedis() {
    this.redis_storage.get('Ciccio');
  }

  deleteRedis() {
    this.redis_storage.remove('Ciccio');
  }

  logout() {
    this.authService.logout().then();
  }
}
